<template>
    <div>
<!--        <router-link  :to="{ name: 'pos_multi_account_edit', params: { hashid: row.stakeholder_hashid }}"-->
<!--                     class="btn btn-sm btn-clean btn-icon btn-icon-sm">-->
<!--            <i class="fa fa-eye"></i>-->
<!--        </router-link>-->
        <a  href="#" @click="deleteMultiAccount" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-trash"></i>
        </a>
    </div>
</template>

<script>
import Vue from 'vue'
import toastr from 'toastr'
import store from '@/store'
import {i18n} from '@/plugins/i18n'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        deleteMultiAccount() {
            let remove_data = {
                stakeholder_id: this.row.stakeholder_hashid,
                index: this.row.index - 1,
            }
           store.dispatch('pos/removeMultiAccount', remove_data).finally(() => {
                this.datatable.reload()
                return this.toastr.success(i18n.t('pos.bank_account_deleted'))
            })

        }
    }
})
</script>